export default "__VITE_ASSET__SbQ1yPux__"